import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTimezone } from '@uplift/contexts';
import { CalendarDateService, DateObject } from '@uplift/services';


const useStyles = makeStyles()(theme => ({
  root: {
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(1),
    }
  }
}));

type ActivityFeedGroupTitleProps = {
  date: string;
  prevDate?: string;
  now: DateObject;
};

export const ActivityFeedGroupTitle: React.VFC<ActivityFeedGroupTitleProps> = ({ date: _date, prevDate: _prevDate, now }) => {
  const { classes } = useStyles();
  const timezone = useTimezone();

  const date = React.useMemo(() => CalendarDateService.date(_date).tz(timezone), [ _date, timezone ]);
  const prevDate = React.useMemo(() => _prevDate && CalendarDateService.date(_prevDate).tz(timezone), [ _prevDate, timezone ]);

  const shouldRender = React.useMemo(() => {
    if (!prevDate) return true;
    return !prevDate.isSame(date, 'date');
  }, [ date, prevDate ]);

  const title = React.useMemo(() => {
    if (!shouldRender) return null;
    return now.isSame(date, 'year') ? date.format('MMM D') : date.format('MMM D, YYYY');
  }, [ date, now, shouldRender ]);

  if (!shouldRender) return null;

  return (
    <Typography variant="overline" color="textSecondary" className={classes.root}>
      {title}
    </Typography>
  );
};
